import ConfigData from "./../Config/index.json";
import { getUserData } from "./http-server";

const useConfig = (): {
  api: string;
} => {
  const data: {
    [key: string]: {
      api: string;
    };
  } = ConfigData;
  const selectedTenant = getUserData()?.current_tenant_name as any;
  console.log(selectedTenant);
  return data[selectedTenant];
};
export default useConfig;
